import { memo, ReactNode } from 'react';
import { Button } from 'antd';
import cn from 'classnames';

import styles from './DangerButton.module.scss';

interface IProps {
  children?: ReactNode;
  className?: string;
  onClick: (event?: any) => void;
  disabled?: boolean;
}

const DangerButton = ({ children, className, onClick, disabled = false }: IProps) => {
  return (
    <Button size='large' className={cn(styles.button, className)} onClick={onClick} disabled={disabled}>
      {children}
    </Button>
  );
};

export default memo(DangerButton);
